import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Grid, Icon, Loader, Responsive, Confirm } from "semantic-ui-react";
import { withRouter, Redirect } from "react-router-dom";
import { postPatient } from "services/patient";
import { setFocusedFolders, resetFocusedFolders, resetWaitingAliquots } from "services/folder";
import { setNurseMode, setSessionCenter, toggleNurseHelp } from "services/user";
import { getMyCenters, resetCenter, setCenter } from "services/center";
import { setCenterBox, resetCenterBox } from "services/box";
import SampleModeButton from "components/Buttons/SampleModeButton";
import FoldersOverview from "features/FoldersOverview";
import NurseMobility from "features/NurseMobility";
import SecretaryHome from "features/SecretaryHome";
import Select from "react-select";
import BlueButton from "components/Buttons/BlueButton";
import { setFilters } from "services/foldersOverview";
import { getAssignedToMeFolderHelp, acceptSupportFolderHelp, cancelFolderHelp, doneFolderHelp } from "services/folderHelp";
import { getBoxStatus } from "services/live";
import { checkDualScreenAvailability } from "utils/dualScreenUtils";
import { openDualScreen, closeDualScreen, setDualScreenAvailability } from "services/dualScreen";
import { withTranslation } from "react-i18next";
import { getMyCenterTourStatus } from "services/center";
import { getAllRoads } from "services/road";

const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

const styles = {
	containerStyle: {
		paddingTop: 30,
	},
	tabs: {
		list: {
			borderBottom: 0,
			marginBottom: 0,
			height: 40,
			display: "flex",
		},
	},
	content: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
	},
};

class Lab extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentFilterSearch: "",
			selectedCenter: null,
			selectedBox: null,
			tabIndex: 0,
			displayNurseFolderHelps: true,
			openFolderManager: false,
			confirmBoxOccupied: "",
			openConfirmBox: false,
			openDualScreenConfirm: false,
		};
	}

	componentDidMount() {
		this.props.resetFocusedFolders();
		if (!this.props.user.session.type) this.props.getMyCenters();
		else if (this.props.user.session.type !== "TVSEC") this.props.getMyCenterTourStatus();
		if (this.props.generalParameters.helpNurse) {
			this.props.getAssignedToMeFolderHelp(this.props.user.session.helpFoldersMyCenter);
			this.props.getFolderHelpCancelReasons();
		}
	}

	openFolderManager = (focusedFolders) => {
		this.props.setFocusedFolders(focusedFolders);
		this.setState({ openFolderManager: true });
	};

	supportHelp = (folderId) => {
		this.props.acceptSupportFolderHelp(folderId);
		this.openFolderManager([folderId]);
	};

	cancelHelp = async (folderId, comment) => {
		await this.props.cancelFolderHelp(folderId, comment);
		this.openFolderManager([folderId]);
	};
	openCancelHelpNurseModal = (folderId) => {
		this.setState({ cancelHelpNurseModal: true, cancelFolderId: folderId });
	};

	closeCancelHelpNurseModal = () => {
		this.setState({ cancelHelpNurseModal: false });
	};
	openHelp = async (folderId) => {
		//await this.props.doneFolderHelp(folderId);
		this.openFolderManager([folderId]);
	};

	changeFilterInput = (event) => {
		event.preventDefault();
		this.setState({ currentFilterSearch: event.target.value });
	};

	/*** ADD FUNCTIONS
	 *
	 */
	newPatient = (values) => {
		this.props.postPatient(values).then((res) => {
			if (values.appointmentDate !== undefined) {
				this.props.setFocusedFolders([res.payload.data.folder.id]);
				this.setState({ openFolderManager: true });
			}
		});
	};

	setMode = (type, nurse = true) => {
		if (type === "CENTER") {
			const { centers } = this.props;
			const { selectedCenter, selectedBox } = this.state;
			const center = selectedCenter ? centers.my.find((cent) => cent.id.toString() === selectedCenter) : null;
			if (center) {
				this.props.setCenter(center);
				const box = center.boxes && center.boxes.length > 0 && selectedBox ? center.boxes.find((b) => b.id.toString() === selectedBox) : null;
				this.props.setCenterBox(center, box).then(() => this.props.getMyCenterTourStatus());
				if (box) {
					this.props.getBoxStatus(box);
				}
				this.props.setSessionCenter(center, box, center.themeHospitalActivated);
				if (!nurse) if (this.props.user.session.nurseHelp && !center.isTvSecActivated) this.props.toggleNurseHelp();
			}
		}
		this.props.setNurseMode(type);
	};

	resetMode = async () => {
		await this.props.resetCenterBox();
		this.props.resetWaitingAliquots();
		this.props.setNurseMode(null);
		this.props.setSessionCenter(null, null);
		this.props.resetCenter();
		this.changeSelectedCenter(null);
		this.props.getMyCenters();
	};

	changeSelectedCenter = (center) => {
		this.setState({ selectedCenter: center });
	};

	changeSelectedBox = (box) => {
		this.setState({ selectedBox: box });
	};

	changeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	selectCustomStyles = {
		container: (provided) => ({
			...provided,
			width: "100%",
			cursor: "pointer",
			margin: "5px 0",
		}),
		option: (provided) => ({
			...provided,
			cursor: "pointer",
		}),
		control: (provided) => ({
			...provided,
			cursor: "pointer",
		}),
	};

	render() {
		const { selectedCenter, openFolderManager, selectedBox } = this.state;
		const { user, centers, generalParameters, safeplaceQR, t } = this.props;
		if (openFolderManager) {
			return <Redirect to="/home/foldermanager" />;
		}

		/*** MODE NURSE ***/
		if (user.session.role === "NURSE" || user.session.role === "SECRETARY") {
			if (user.session.type === null) {
				return (
					<Grid>
						<Grid.Row style={{ marginTop: 80 }}>
							<Grid.Column
								mobile={16}
								tablet={16}
								computer={16}
								style={{
									display: "flex",
									justifyContent: "center",
									marginTop: isMobile() ? 20 : 0,
								}}
							>
								<Card style={{ width: "100%", boxShadow: "1px 1px 2px #fff" }}>
									<Card.Header style={{ width: "100%", textAlign: "center", marginTop: 9, fontSize: 40 }}>
										<Icon name="home" size="large" style={{ marginBottom: 20 }} />
									</Card.Header>
									<Card.Description style={styles.content}>
										<h3 className="ui header">{t("home.center")}</h3>
									</Card.Description>
									<Card.Content style={styles.content}>
										{centers.loading && <Loader active inline />}
										{!centers.loading && centers.my !== null && centers.my.length > 0 && (
											<Select
												name="center"
												customlabel={t("home.yourcenter")}
												value={selectedCenter}
												options={centers.my.map((i) => ({
													value: String(i.id),
													label: `${i.abbreviation} - ${i.name}`,
												}))}
												onChange={this.changeSelectedCenter}
												required
												styles={this.selectCustomStyles}
												placeholder={t("home.selectcenter")}
											/>
										)}
										{centers.loading && <Loader active inline />}
										{!centers.loading &&
											centers.my !== null &&
											centers.my.length > 0 &&
											selectedCenter &&
											centers.my.find((cent) => cent.id.toString() === selectedCenter.value) &&
											centers.my.find((cent) => cent.id.toString() === selectedCenter.value).boxes &&
											centers.my.find((cent) => cent.id.toString() === selectedCenter.value).boxes.length > 0 && (
												<Select
													name="box"
													customlabel={t("home.yourbox")}
													value={selectedBox}
													options={centers.my
														.find((cent) => cent.id.toString() === selectedCenter.value)
														.boxes.map((i) => ({
															value: String(i.id),
															label: `${i.name} ${
																!!i.occupied_by
																	? `- ${t("home.busyby")} ${
																			i.occupied_by.user ? i.occupied_by.user.first_name + " " + i.occupied_by.user.last_name : "?"
																	  }`
																	: ""
															}`,
															occupied_by: `${
																!!i.occupied_by && i.occupied_by.user ? i.occupied_by.user.first_name + " " + i.occupied_by.user.last_name : ""
															}`,
														}))}
													onChange={this.changeSelectedBox}
													required
													styles={this.selectCustomStyles}
													placeholder={t("home.selectbox")}
												/>
											)}
									</Card.Content>
									<Card.Content style={{ display: "flex", alignItems: "center" }}>
										<Grid columns={2} style={{ flex: 1 }}>
											<Grid.Row>
												<Grid.Column
													mobile={16}
													tablet={user.session.role === "SECRETARY" && generalParameters.data.helpNurse ? 6 : 16}
													computer={user.session.role === "SECRETARY" && generalParameters.data.helpNurse ? 8 : 16}
												>
													<SampleModeButton
														onClick={async (e) => {
															if (e !== undefined) e.preventDefault();
															if (selectedBox && selectedBox.occupied_by) {
																await this.setState({ confirmBoxOccupied: selectedBox.occupied_by, openConfirmBox: true });
															} else {
																await this.setState({
																	selectedCenter: selectedCenter ? selectedCenter.value : null,
																	selectedBox: selectedBox ? selectedBox.value : null,
																});

																checkDualScreenAvailability(this.props.setDualScreenAvailability);
																this.props.setFilters(new Date(), new Date(), false, 1, "", 20, false, selectedBox ? true : false);
																this.setMode("CENTER");
															}
														}}
														text={t("home.centermode")}
														disabled={
															selectedCenter === null ||
															(user.session.role !== "SECRETARY" &&
																centers.my.find((cent) => cent.id.toString() === selectedCenter.value) &&
																centers.my.find((cent) => cent.id.toString() === selectedCenter.value).boxes &&
																centers.my.find((cent) => cent.id.toString() === selectedCenter.value).boxes.length > 0 &&
																centers.my.find((cent) => cent.id.toString() === selectedCenter.value).boxes.filter((b) => !b.occupied_by).length >
																	0 &&
																selectedBox === null)
														}
													/>
													<Confirm
														open={this.state.openConfirmBox}
														content={t("home.usedby", { name: this.state.confirmBoxOccupied })}
														cancelButton={t("home.cancel")}
														confirmButton={t("home.confirm")}
														onCancel={(e) => {
															if (e !== undefined) e.preventDefault();
															this.setState({
																openConfirmBox: false,
															});
														}}
														onConfirm={async (e) => {
															if (e !== undefined) e.preventDefault();
															await this.setState({
																selectedCenter: selectedCenter ? selectedCenter.value : null,
																selectedBox: selectedBox ? selectedBox.value : null,
															});
															this.props.setFilters(new Date(), new Date(), false, 1, "", 20, false, selectedBox ? true : false);
															this.setMode("CENTER");
														}}
													/>
												</Grid.Column>
												{user.session.role === "SECRETARY" && generalParameters.data.helpNurse && (
													<Grid.Column mobile={16} tablet={8} computer={8}>
														<BlueButton
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																this.changeSelectedCenter(null);
																this.setMode("TVSEC", false);
															}}
															text={
																<>
																	<Icon name="bell" /> {t("home.telesec")}
																</>
															}
															style={{ width: "100%" }}
														/>
													</Grid.Column>
												)}
											</Grid.Row>
										</Grid>
									</Card.Content>
								</Card>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				);
			} else if (user.session.type === "CENTER") {
				if (user.session.role === "NURSE")
					return (
						<>
							<FoldersOverview
								openSidebar={this.props.openSidebar}
								hideSidebar={this.props.hideSidebar}
								resetMode={this.resetMode}
								safeplaceQR={safeplaceQR}
								campaignQR={this.props.campaignQR}
							/>
						</>
					);
				else if (user.session.role === "SECRETARY")
					return (
						<>
							<SecretaryHome openSidebar={this.props.openSidebar} hideSidebar={this.props.hideSidebar} resetMode={this.resetMode} />
						</>
					);
			} else if (user.session.type === "MOBILITY") {
				return (
					<NurseMobility
						openSidebar={this.props.openSidebar}
						hideSidebar={this.props.hideSidebar}
						resetMode={this.resetMode}
						getAllRoads={this.props.getAllRoads}
					/>
				);
			} else if (user.session.type === "TVSEC") {
				return <SecretaryHome openSidebar={this.props.openSidebar} hideSidebar={this.props.hideSidebar} resetMode={this.resetMode} tvsec />;
			}
		} else {
			return <div>Rôle utilisateur non pris en charge</div>;
		}
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.user,
		patients: state.patients,
		round: state.round,
		labAppointment: state.labAppointment,
		generalParameters: state.generalParameters,
		centers: state.centers,
		myNurseFolderHelps: state.folderHelp.myNurseFolderHelps,
		boxes: state.boxes,
		safeplaceQR: state.safeplace.safeplaceQR,
		campaignQR: state.campaigns.campaignQR,
		dualScreen: state.dualScreen,
	};
};

const mapDispatchToProps = {
	postPatient,
	setFocusedFolders,
	setNurseMode,
	setSessionCenter,
	getMyCenters,
	resetFocusedFolders,
	resetCenter,
	setFilters,
	setCenter,
	getAssignedToMeFolderHelp,
	acceptSupportFolderHelp,
	cancelFolderHelp,
	doneFolderHelp,
	setCenterBox,
	resetCenterBox,
	getBoxStatus,
	resetWaitingAliquots,
	openDualScreen,
	closeDualScreen,
	setDualScreenAvailability,
	toggleNurseHelp,
	getMyCenterTourStatus,
	getAllRoads,
};

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Lab)));
